import { SparklesIcon } from "@heroicons/react/24/outline";
import React from "react";
import { Trans } from "@lingui/react/macro";

export default function AnnotateAskAI({
  setAskingAI,
}: {
  setAskingAI: (askingAI: boolean) => void;
}) {
  return (
    <button
      onClick={() => setAskingAI(true)}
      className="flex text-sm sm:text-base justify-center h-10 px-2 items-center sm:px-4 cursor-pointer space-x-1 text-primary"
    >
      <span><Trans>Ask AI</Trans></span>
      <SparklesIcon className="h-5 w-5" />
    </button>
  );
}
